import "core-js/modules/es.array.push.js";
import { ToastProgrammatic as Toast } from 'buefy';
import Error from '../error';
import sha256 from 'crypto-js/sha256';
export default {
  name: "Login",
  data() {
    return {
      inep: undefined,
      password: undefined,
      isSignInRequestInProgress: false
    };
  },
  methods: {
    login() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const adviser = {
            inep: this.inep,
            password: sha256(this.password).toString()
          };
          this.isSignInRequestInProgress = true;
          this.$store.dispatch('authRequest', adviser).then(() => {
            localStorage.setItem('inep', +this.inep);
            this.$store.commit('setInep', +this.inep);
            this.$store.dispatch('getSchool').then(() => {
              this.$router.push('/home');
              this.isSignInRequestInProgress = false;
            });
          }).catch(error => {
            if (error.data) {
              Toast.open(Error[error.data.errorCode]);
            }
          }).then(() => {
            this.isSignInRequestInProgress = false;
          });
        }
      });
    }
  }
};